import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=406c1df7&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406c1df7')) {
      api.createRecord('406c1df7', component.options)
    } else {
      api.reload('406c1df7', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=406c1df7&", function () {
      api.rerender('406c1df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Cf3Ey87TF7x/JS/pricehelp.vue"
export default component.exports